import type { Column } from '@tanstack/react-table';

/**
 * Returns the display label for a column's filter.
 * Priority: meta.filter.label > header (if string) > column id
 */
export function getFilterLabel<TData>(column: Column<TData>): string {
  const meta = column.columnDef.meta?.filter;

  if (meta?.label) {
    return meta.label;
  }

  const header = column.columnDef.header;

  if (typeof header === 'string') {
    return header;
  }

  return column.id;
}
